import "./Home.module.css";
import Navigation from "@/reusable_sections/Header";
import Visionary from "./sections/Visionary";
import Pillars from "./sections/Pillars";
import Studio from "./sections/Studio";
import Partners from "./sections/Partners";
import Impact from "./sections/Impact";
import TheVisionary from "./sections/TheVisionary";
import Social from "./sections/Social";
import Collaboration from "./sections/Collaboration";
import VisionaryCopy from "./sections/VisionaryCopy";
import Connect from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <Navigation />
      <Visionary />
      <VisionaryCopy />
      <Pillars />
      <Studio />
      <Partners />
      <Impact />
      <TheVisionary />
      <Social />
      <Collaboration />
      <Connect />
    </div>;
}